import NotificationSettings from 'components/NotificationSettings';
import PermissionGuard from 'components/Global/PermissionGuard';


export const Notification = () => {
	return (
		<PermissionGuard isAdmin={true}>
			<NotificationSettings />
		</PermissionGuard>
	);
};
export default Notification;
